import { criarInstanciador } from '@/uteis/action/atribuir/instanciador'

export const atribuir = (processo, dadosSessao) => {
  var dados = {
    titulo: '',
    descricao: '',
    processo: processo.data.processo,
    assunto: processo.data.atributos.assunto,
    instanciador: criarInstanciador(dadosSessao)
  }

  return dados
}
